export default __webpack_public_path__ + "images/alarmcentraleaf972d5db0ba1da982cf59e1e749a205.svg";